import { render, staticRenderFns } from "./CloneButton.vue?vue&type=template&id=ec8f078c&"
import script from "./CloneButton.vue?vue&type=script&lang=js&"
export * from "./CloneButton.vue?vue&type=script&lang=js&"
import style0 from "./CloneButton.vue?vue&type=style&index=0&id=ec8f078c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports